import { pendingSelector } from 'api/selectors'

export const authStateSelector = state => state.loginAndSignup || {}

export const authFormStateSelector = createSelector(authStateSelector, auth => auth.state)

export const loginErrorSelector = state =>
    state.pending.login && state.pending.login instanceof Error && state.pending.login.message

export const createAccountErrorSelector = state =>
    state.pending.createAccount && state.pending.createAccount instanceof Error && state.pending.createAccount.message

export const loginPendingSelector = createSelector(pendingSelector, pending => pending.login || false)
